const DURATION = 1700
const STEPS = 408
const DT = 1 / 240
let cachedFrames

// Sample three coupled, damped springs once. The browser plays the resulting
// steady-state orbit, so the loop has no reset and needs no per-frame React work.
export function getGenerationMotionFrames() {
    if (cachedFrames) return cachedFrames
    const position = [0, 0, 0]
    const velocity = [0, 0, 0]
    const frames = [[], [], []]
    const travel = [3, 1.85, 1.65]

    for (let step = 0; step <= STEPS * 9; step += 1) {
        const phase = (step % STEPS) * DT
        if (step >= STEPS * 8 && step % 4 === 0) {
            position.forEach((value, band) => {
                const lift = Math.min(1, Math.max(0, value / travel[band]))
                frames[band].push({
                    offset: (step - STEPS * 8) / STEPS,
                    transform: `translateY(${-value}px)`,
                    opacity: 1 - 0.78 * lift * lift * (3 - 2 * lift)
                })
            })
        }

        // A smooth push on the bottom spring transfers force through its neighbours.
        const primaryPush = phase < 0.38 ? 3.8 * Math.sin((Math.PI * phase) / 0.38) ** 2 : 0
        // A much smaller follow-through keeps a little spring motion at the seam.
        // Both force pulses meet zero with zero slope, avoiding a visible kick.
        const echoPhase = phase - 1.02
        const echoPush = echoPhase > 0 && echoPhase < 0.32 ? 0.42 * Math.sin((Math.PI * echoPhase) / 0.32) ** 2 : 0
        const drive = primaryPush + echoPush
        const acceleration = [
            190 * (drive - position[0]) - 12 * velocity[0] + 110 * (position[1] - position[0]),
            110 * (position[0] - 2 * position[1] + position[2]) - 45 * position[1] - 5.8 * velocity[1],
            (110 * (position[1] - position[2]) - 40 * position[2] - 5.6 * velocity[2]) / 0.85
        ]
        position.forEach((_, band) => {
            velocity[band] += acceleration[band] * DT
            position[band] += velocity[band] * DT
        })
    }

    // The warm-up converges to a periodic orbit; join the endpoints exactly.
    frames.forEach((band) => {
        band[band.length - 1] = { ...band[0], offset: 1 }
    })
    cachedFrames = frames
    return frames
}

export function animateGenerationMark(mark) {
    const bands = ['bottom', 'middle', 'top'].map((band) => mark.querySelector(`.ai-generation-loading__band--${band}`))
    if (bands.some((band) => !band || typeof band.animate !== 'function')) return () => {}
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)')
    let animations = []
    const stop = () => {
        animations.forEach((animation) => animation.cancel())
        animations = []
    }
    const sync = () => {
        stop()
        if (preference.matches) return
        const frames = getGenerationMotionFrames()
        animations = bands.map((band, index) =>
            band.animate(frames[index], { duration: DURATION, iterations: Infinity, easing: 'linear' })
        )
    }
    sync()
    preference.addEventListener('change', sync)
    return () => {
        stop()
        preference.removeEventListener('change', sync)
    }
}
